import React from 'react';
import Icon from 'components/general/Icon/Icon';

const Figure: React.SFC<FigurePropDef> = ({ children, caption }) => (
  <figure className="figure">
    <div className="figure__graphic">
      {children}
    </div>
    <figcaption className="figure__caption">
      <Icon name="camera" className="figure__caption-icon" />
      {caption}
    </figcaption>
  </figure>
);

interface FigurePropDef {
  caption: string;
}

export default Figure;
